// Helper cliente pra buscar cotações (VET) da API de câmbio do backend.
//
// O backend (functions/api/currency/rates.js) já cacheia no KV e aplica o
// markup da VET (spread + IOF) configurado pelo admin. Aqui só embrulhamos o
// authFetch e devolvemos o mapa `vet` na convenção do app
// (rate[X] = quantos da base valem 1 X), pronto pra virar `currencyRates`.

import { authFetch } from './auth.js';
import { API } from './api.js';

/**
 * Busca as cotações VET pra uma moeda-base.
 *
 * @param {string} base moeda-base (default 'BRL')
 * @returns {Promise<{ base:string, markupPct:number, source:string,
 *   fetchedAt:number, commercial:Record<string,number>, vet:Record<string,number> }>}
 * @throws {Error} se a API falhar (o caller degrada com elegância)
 */
export async function fetchApiRates(base = 'BRL') {
  const res = await authFetch(API.currencyRates(base));
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const d = await res.json(); if (d?.error) msg = d.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  const data = await res.json();
  if (!data || typeof data.vet !== 'object') {
    throw new Error('Resposta inválida da API de câmbio');
  }
  return data;
}
